/**
 * Payment Element options: address is collected in checkout step 1 (AO-342).
 * @param {string} [userEmail]
 * @returns {{
 *   layout: string;
 *   wallets: { applePay: string; googlePay: string; link: string };
 *   paymentMethodOrder: string[];
 *   fields: { billingDetails: { address: string } };
 *   defaultValues?: { billingDetails: { email: string } };
 * }}
 */
export function getPaymentElementOptions(userEmail) {
  const secure = typeof window !== "undefined" && window.location.protocol === "https:";
  /** @type {{
   *   layout: string;
   *   wallets: { applePay: string; googlePay: string; link: string };
   *   paymentMethodOrder: string[];
   *   fields: { billingDetails: { address: string } };
   *   defaultValues?: { billingDetails: { email: string } };
   * }} */
  const options = {
    layout: "tabs",
    wallets: {
      applePay: secure ? "auto" : "never",
      googlePay: secure ? "auto" : "never",
      // Link stores cards for reuse; keep card checkout without saved-card prompts.
      link: "never",
    },
    paymentMethodOrder: ["card"],
    fields: {
      billingDetails: {
        address: "never",
      },
    },
  };

  if (userEmail) {
    options.defaultValues = { billingDetails: { email: userEmail } };
  }

  return options;
}
